// eslint-disable-next-line no-shadow
export var TipType;
(function (TipType) {
    TipType["TipTypePercent"] = "percent";
    TipType["TipTypeCurrencyAmount"] = "currencyAmount";
})(TipType || (TipType = {}));
//# sourceMappingURL=Payment.js.map